<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Πιστοποιητικά</h4>
          <CButton class="m-3" color="primary" @click="createCert()">Έκδοση πιστοποιητικού</CButton>
        </CCardHeader>
        <CCardBody>
          <CTabs>
            <CTab title="Έκδοση Πιστοποιητικού" active>
              <CCard>
                <CCardBody>
                  <CModal
                    class="modalAlert"
                    :show.sync="alertIsShown"
                    :centered="true"
                    size="lg"
                  >
                    <CAlert
                      closeButton
                      :show.sync="alertIsShown"
                      color="primary"
                      fade
                    >
                      {{ message }}
                    </CAlert>
                  </CModal>
                  <CDataTable
                    :items="filteredItems"
                    :fields="fields"
                    :items-per-page="10"
                    pagination
                    column-filter
                    table-filter
                    hover
                    striped
                    :loading="loading"
                    sorter
                    @row-clicked="(item) => editCert(item.id)"
                    clickable-rows
                  >
                  <template #status-filter>
                    <div class="selectFilter">
                      <CSelect
                        :options="statusOptions"
                        :value.sync="selectedOption"
                      />
                    </div>
                  </template>
                    <template #actions="{item}">
                      <td class="button-cell">
                        <CButton
                          color="primary"
                          class="btn-icon mr-2"
                          @click.stop="editCert( item.id )"
                          v-c-tooltip="'Επεξεργασία'"
                        >
                          <CIcon name="cilPencil" />
                        </CButton>
                        <CButton
                          v-if="you!=item.id"
                          color="danger"
                          class="btn-icon"
                          @click.stop="deleteCert( item.id )"
                          v-c-tooltip="'Διαγραφή'"
                        >
                          <CIcon name="cilTrash" />
                        </CButton>
                      </td>
                    </template>
                  </CDataTable>
                </CCardBody>
              </CCard>
            </CTab>
            <CTab title="Διαγραμμένα">
              <CCard>
                <CCardBody>
                  <CModal
                    class="modalAlert"
                    :show.sync="alertIsShown"
                    :centered="true"
                    size="lg"
                  >
                    <CAlert
                      closeButton
                      :show.sync="alertIsShown"
                      color="primary"
                      fade
                    >
                      {{ message }}
                    </CAlert>
                  </CModal>
                  <CDataTable
                    :items="deletedItems"
                    :fields="deletedFields"
                    :items-per-page="10"
                    pagination
                    column-filter
                    table-filter
                    hover
                    striped
                    :loading="loading"
                    sorter
                  >
                    <template #actions="{item}">
                      <td class="button-cell">
                        <CButton
                          v-if="you!=item.id"
                          color="success"
                          class="btn-icon"
                          @click.stop="restoreCert( item.id )"
                          v-c-tooltip="'Ανάκτηση'"
                        >
                          <CIcon name="cilReload" />
                        </CButton>
                      </td>
                    </template>
                  </CDataTable>
                </CCardBody>
              </CCard>
            </CTab>
          </CTabs>

        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  {
    key: 'client', 
    label: 'Πελάτης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'service', 
    label: 'Πρότυπο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'certification_date', 
    label: 'Ημερομηνία Έκδοσης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'expiration_date', 
    label: 'Ημερομηνία Λήξης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'status',
    label: 'Κατάσταση',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
];

const deletedFields = [
  {
    key: 'client', 
    label: 'Πελάτης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'service', 
    label: 'Πρότυπο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'certification_date', 
    label: 'Ημερομηνία Έκδοσης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'expiration_date', 
    label: 'Ημερομηνία Λήξης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'status',
    label: 'Κατάσταση',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Certifications',
  data: () => {
    return {
      items: [],
      deletedItems: [],
      fields,
      deletedFields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      loading: true,
      alertIsShown: false,
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      isActive: false,
      restoreCertificate: true,
      statusOptions: ['Καμία επιλογή'],
      selectedOption: 'Καμία επιλογή',
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getBadge (status) {
      return status ? 'success' : 'secondary'
    },
    getBadgeText (status) {
      return status ? 'Ενεργός' : 'Ανενεργός'
    },
    editLink (id) {
      return `certifications/${id.toString()}/edit`
    },
    editCert ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteCert ( id ) {
      let self = this;
      axios.post('/api/certifications/deleteCertification/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'POST',
        isActive: self.isActive
      })
      .then(function (response) {
          self.message = 'Επιτυχής διαγραφή πιστοποιητικού.';
          self.showAlert();
          self.getCertifications();
          self.getDeletedCertifications();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    restoreCert ( id ) {
      let self = this;
      axios.post('/api/certifications/deleteCertification/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'POST',
        isActive: self.restoreCertificate
      })
      .then(function (response) {
          self.message = 'Επιτυχής ανάκτηση πιστοποιητικού.';
          self.showAlert();
          self.getCertifications();
          self.getDeletedCertifications();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getCertifications (){
      let self = this;
      axios.get('/api/certifications/filteredActiveCertifications' + '?isActive=1' + '&token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.certifications.map((item) => {
          item.client = item.client.company;
          item.service = item.service.name;
          item.status = item.status.name;
          return item;
        })
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    getCertStatuses (){
      let self = this;
      axios.get('/api/certification/statuses')
      .then(function (response) {
        console.log(response.data);
        self.statusOptions = ['Καμία επιλογή', ...[
    "Σε ισχύ",
    "Έχει λήξει",
    "Έχει ανακληθεί",
    "Έχει ανασταλεί"
]];
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    getDeletedCertifications (){
      let self = this;
      axios.get('/api/certifications/filteredActiveCertifications' + '?isActive=0' + '&token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.deletedItems = response.data.certifications.map((item) => {
          item.client = item.client.company;
          item.service = item.service.name;
          item.status = item.status.name;
          return item;
        })
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    createCert () {
      this.$router.push({path: 'certifications/create'});
    },
  },
  computed: {
    filteredItems() {
      if (this.selectedOption == "Καμία επιλογή" || this.selectedOption == '') {
        return this.items;
      }
      return this.items.filter(item => {
        return item.status == this.selectedOption;
      });
    }
  },
  mounted: function(){
    this.getCertStatuses();
    this.getCertifications();
    this.getDeletedCertifications();
  }
}
</script>
